// Deduplica le carte mostrando una sola "stampa base" per carta.
// Le varianti estetiche hanno suffissi tra parentesi nel nome,
// es. "Ornn - Fire Below the Mountain (Metal)" / "(Overnumbered)" / "(Alternate Art)".

// Nome base: rimuove i suffissi finali tra parentesi.
export function baseCardName(name = '') {
  let n = String(name);
  while (/\s*\([^()]*\)\s*$/.test(n)) {
    n = n.replace(/\s*\([^()]*\)\s*$/, '');
  }
  return n.trim();
}

// Punteggio "non-base": più basso = più vicino alla stampa base canonica.
function variantScore(card) {
  let s = 0;
  if (baseCardName(card.name) !== String(card.name || '').trim()) s += 10; // ha un suffisso variante
  if (card.overnumbered === true) s += 5;
  if (String(card.rarity || '').toLowerCase() === 'promo') s += 2;
  return s;
}

// Restituisce una sola carta per (nome base + tipo): la stampa base.
export function baseCardsOnly(cards = []) {
  const groups = new Map();
  for (const card of cards) {
    if (!card || !card.name) continue;
    const key = `${baseCardName(card.name)}|${card.type || ''}`;
    const current = groups.get(key);
    if (!current || variantScore(card) < variantScore(current)) {
      groups.set(key, card);
    }
  }
  return [...groups.values()];
}
